import React, { useRef } from 'react';
var VeltNotificationsPanelHeaderTabAll = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-header-tab-all", { ref: ref }, children));
};
export default VeltNotificationsPanelHeaderTabAll;
